// Competizioni di VC: "due app dentro la stessa app" (uomini / donne), stesso modello di Virtua Basket (lib/competitionThemes.js di VB).
// id coerenti con dim_competition. Le leghe (dim_league.id_competition) separano tutto il resto: le RPC fn_* sono per lega.
export const DEFAULT_COMPETITION_ID = 1 // uomini

export const COMPETITIONS = [
  { id: 1, key: 'men', labelKey: 'competition.men' },
  { id: 2, key: 'women', labelKey: 'competition.women' },
]

export const isValidCompetition = (id) => COMPETITIONS.some(c => c.id === id)
